import { t } from '../../../dictionary'
import {
  Period,
  PeriodName,
} from '../../../modules/page-content/page-content.types'

const kitDayPeriodNames = Object.keys(PeriodName)

export const getSortedPeriods = (periods: Period[] = []) => {
  const sortedPeriods: Period[] = []

  periods.forEach(period => {
    kitDayPeriodNames.forEach((kitName, index) => {
      if (period.name === kitName.toUpperCase()) {
        sortedPeriods[index] = period
      }
    })
  })
  return sortedPeriods
}

export const getPeriodName = (name: string) => {
  const periodNames = Object(t.periodNames)
  return periodNames[name.toLowerCase()]
}
